




































import { Component, Vue, Prop } from 'vue-property-decorator';
import { EmbeddedContentType } from 'client-website-ts-library/types/EmbeddedContent/EmbeddedContent';

import {
  ItemCyclerSlide,
  ItemCyclerSlideType,
  ItemCyclerEmbeddableSlide,
} from '../../app_code/ItemCycler';
import { CarouselBreakpoint } from '../../app_code/CarouselBreakpoint';

import Cycler from './Cycler.vue';
import CyclerItem from './CyclerItem.vue';
import ItemCyclerItem from './ItemCyclerItem.vue';

@Component({
  components: {
    Cycler,
    CyclerItem,
    ItemCyclerItem,
  },
})
export default class ItemCycler extends Vue {
  @Prop()
  public readonly objects!: ItemCyclerSlide[];

  @Prop()
  public readonly darken!: boolean;

  @Prop({ required: true })
  public readonly items!: number;

  @Prop()
  public readonly autoAdvance!: boolean;

  @Prop({ default: 5000 })
  public readonly autoAdvanceInterval!: number;

  @Prop({ default: 2500 })
  public readonly speed!: number;

  @Prop({ default: true })
  public readonly loop!: boolean;

  @Prop({ default: false })
  public readonly darkNav!: boolean;

  @Prop({ default: true })
  public readonly hideNav!: boolean;

  @Prop({ default: false })
  public readonly hideAgileNav!: boolean;

  @Prop()
  public readonly center!: boolean;

  @Prop({ default: () => [] })
  public readonly responsive!: CarouselBreakpoint[];

  public index = 0;

  get videoIndex(): number {
    return this.objects.findIndex(
      (obj) =>
        obj.type === ItemCyclerSlideType.Embeddable &&
        ((obj as ItemCyclerEmbeddableSlide).embeddable.Type ===
          EmbeddedContentType.Youtube ||
          (obj as ItemCyclerEmbeddableSlide).embeddable.Type ===
            EmbeddedContentType.Vimeo),
    );
  }

  get showVideoNav(): boolean {
    const idx = this.videoIndex;

    return idx !== -1 && idx !== this.index;
  }

  navToVideo(): void {
    (this.$refs.cycler as any).goToIndex(this.videoIndex);

    this.$emit('viewVideo');
  }

  handleUpdate(data: any): void {
    this.index = data.index;
  }
}
